import React from 'react';
import ABTestWrapper from '../../Components/ABTestWrapper';
import LandingA from './LandingA';  // Import the current landing page as VariantA
import LandingB from './LandingB';  // Import the new variant B

const Landing = () => {
  return (
    <ABTestWrapper
      variantA={<LandingA />}
      variantB={<LandingB />}
    />
  );
};

export default Landing;
